import { createRouter, createWebHashHistory } from 'vue-router'
import { useStore } from '@/store'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { public: true }
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/views/Layout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '首页', icon: 'HomeFilled' }
      },
      {
        path: '/products',
        name: 'Products',
        component: () => import('@/views/Products.vue'),
        meta: { title: '产品管理', icon: 'GoodsFilled' }
      },
      {
        path: '/customers',
        name: 'Customers',
        component: () => import('@/views/Customers.vue'),
        meta: { title: '客户管理', icon: 'UserFilled' }
      },
      {
        path: '/quotations',
        name: 'Quotations',
        component: () => import('@/views/Quotations.vue'),
        meta: { title: '报价管理', icon: 'DocumentChecked' }
      },
      {
        path: '/quotations/create',
        name: 'CreateQuotation',
        component: () => import('@/views/QuotationForm.vue'),
        meta: { title: '新建报价', hidden: true }
      },
      {
        path: '/quotations/edit/:id',
        name: 'EditQuotation',
        component: () => import('@/views/QuotationForm.vue'),
        meta: { title: '编辑报价', hidden: true }
      },
      {
        path: '/orders',
        name: 'Orders',
        component: () => import('@/views/Orders.vue'),
        meta: { title: '订单管理', icon: 'List' }
      },
      {
        path: '/statistics',
        name: 'Statistics',
        component: () => import('@/views/Statistics.vue'),
        meta: { title: '数据统计', icon: 'TrendCharts' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const store = useStore()
  
  if (to.meta?.public) {
    next()
    return
  }
  
  if (!store.token) {
    next('/login')
  } else {
    next()
  }
})

export default router
